import { RootState } from '../store';
import { createReducer } from '../core';

export type DebugState = {
  enabled: boolean;
  downloadMedia: boolean;
  downloadFrames: boolean;
  enableFaceTrackerUi: boolean;
};

export function newDebugState(): DebugState {
  return {
    enabled: false,
    downloadMedia: false,
    downloadFrames: false,
    enableFaceTrackerUi: false,
  };
}

// Reducers

export const loadDebugSlice = createReducer((state, payload: DebugState) => {
  state.debug = {
    ...newDebugState(),
    ...payload,
  }
});


export const setDebugSettings = createReducer((state, payload: Partial<DebugState>) => {
  state.debug = {
    ...state.debug,
    ...payload,
  }
})

// Selectors

export const selectDebugSettings = () => (state: RootState) => {
  return state.debug;
}
